import { render, staticRenderFns } from "./manageFreight.vue?vue&type=template&id=2c948c3a&"
import script from "./manageFreight.vue?vue&type=script&lang=js&"
export * from "./manageFreight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports